<template>
  <div class="Com_4">
    <title1 type="2" title="环境信息" :right="true">
      <template v-slot:tab>
      </template>
    </title1>
    <div
      class="box-item flex justify-content-evenly"
      style="width: 565px;"
    >
      <div :class="['small-box']" v-for="(item, index) in list" :key="index">
		  <div class="left">
			  <img :src="item.img" alt="">
		  </div>
		  <div class="right">
			  <div class="small-top">{{ item.name }}</div>
			  <div class="small-center">{{ item.number }}</div>
		  </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import title1 from "@/views/exposition/components/title3";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyEcharts,
    title1,
  },
  data() {
    return {
      showcdata: false,
      list: [
        {
			img:require('@/assets/images/photovoltaic/xinxi1.png'),
          name: "辐射度（Wm²）",
          number: "6",
          typeNumber: "431",
        },
        {
			img:require('@/assets/images/photovoltaic/xinxi2.png'),
          name: "辐射量(J)",
          number: "56%",
          typeNumber: "3123",
        },
		{
			img:require('@/assets/images/photovoltaic/xinxi3.png'),
		  name: "天气",
		  number: "晴天",
		  typeNumber: "3123",
		},
		{
			img:require('@/assets/images/photovoltaic/xinxi4.png'),
		  name: "温度(°C)",
		  number: "21",
		  typeNumber: "3123",
		},
		{
			img:require('@/assets/images/photovoltaic/xinxi5.png'),
		  name: "风向",
		  number: "东风",
		  typeNumber: "3123",
		},
		{
			img:require('@/assets/images/photovoltaic/xinxi6.png'),
		  name: "风速(m/s)",
		  number: "12",
		  typeNumber: "3123",
		},
      ],
      tabList: [
        {
          name: "日",
        },
        {
          name: "月",
        },
        {
          name: "年",
        },
      ],
      indexc: 0,
    };
  },
  mounted() {
    this.getBattery24hours()
  },
  destroyed() {},
  methods: {
    tabClick(item, index) {
      this.indexc = index || 0;
    },
    getBattery24hours() {
      // const now = new Date();
      // const year = now.getFullYear();
      // const month = (now.getMonth() + 1).toString().padStart(2, "0");
      // const day = now.getDate().toString().padStart(2, "0");
      // const timer = `${year}-${month}-${day}`;
      let params = {
          "enCode": "zngf-dz-huanjing-xinxi",// 接口code
        "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
      }
      this.showcdata = false;
	  let that = this
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "环境信息");
          console.log(res[0].fzd, "环境信息");
          if (res && res[0]) {
			  that.list[0].number = res[0].fzd
			  that.list[1].number = res[0].fsl
			  that.list[2].number = res[0].tq
			  that.list[3].number = res[0].wd
			  that.list[4].number = res[0].fx
			  that.list[5].number = res[0].fs
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
@import "@/assets/scss/comm.scss";
.Com_4 {
  .title-3 {
    width: 35%;
    height: 90%;
    background: url(~@/assets/images/myComm/title-3-3.png) left bottom no-repeat;
    background-size: 100% 54px;
    float: right;
    .tabItem {
      padding: 0 2px;
      display: inline-block;
      height: 100%;
      display: flex;
      align-items: center;
      color: rgba(0, 178, 188, 1);
    }
    .active {
      color: rgba(192, 251, 248, 1);
      border-bottom: 2px solid rgba(192, 251, 248, 1);
    }
  }
  .box-item {
    width: 562px;
    height: 100%;
    padding: 10px 0 5px 0;
	flex-wrap: wrap;
    .small-box {
      width: 260px;
      height: 100px;
	  background: url(~@/assets/images/photovoltaic/item_box.png) left bottom no-repeat;
	  background-size: 100% 100%;
      display: flex;
	  margin-bottom: 20px;
	  .left{
		  width: 90px;
		img{
			margin-top: 10px;
			margin-left: 10px;
			width: 84px;
		}
	  }
	  .right{
		  font-weight: 600;
		 .small-top {
			 width: 100%;
			 height: 68px;
			 line-height: 78px;
			 font-size: 20px;
			 padding-left: 20px;
		 }
		 .small-center {
		   width: 100%;
		   height: 20px;
		   padding-left: 20px;
		   line-height: 20px;
		   color: rgba(255, 255, 255, 0.9);
		   font-size: 24px;
		 } 
	  }
      
      .small-bottom {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        padding-left: 20px;
      }
    }
  }
}
</style>